import Model from './Model'

export default class Affiliation extends Model {
  createdAt: string
  email: string
  firstName: string
  lastName: string
  avatarId: number
  id: number

  constructor(json) {
    super({})
    this.id = json.id
    this.createdAt = json.affiliate_at
    this.email = json.email
    this.firstName = json.first_name
    this.lastName = json.last_name
    this.avatarId = json.picture
  }
}
